import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
} from "react-bootstrap";

const Co2ConverterModal = ({ show, onHide, onApply, initialValue }) => {
  const [volCo2, setVolCo2] = useState("");

  useEffect(() => {
    if (show) {
      if (
        initialValue &&
        !isNaN(parseFloat(initialValue)) &&
        parseFloat(initialValue) > 0
      ) {
        setVolCo2((parseFloat(initialValue) / 1.96).toFixed(2));
      } else {
        setVolCo2("");
      }
    }
  }, [show, initialValue]);

  const numVol = parseFloat(volCo2);
  const convertedGPerL =
    !isNaN(numVol) && numVol > 0 ? (numVol * 1.96).toFixed(2) : null;

  const handleApply = () => {
    if (convertedGPerL) {
      onApply(convertedGPerL);
    }
  };

  return (
    <Modal show={show} onHide={onHide} bsSize="small">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "18px", fontWeight: "bold" }}>
          Convert CO2 Carbonation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ color: "#666", fontSize: "13px", marginBottom: "15px" }}>
          Enter carbonation in Volumes of CO2 (vol. CO2) to calculate the
          equivalent value in grams per liter (g/L CO2).
        </p>
        <FormGroup controlId="volCo2Input">
          <ControlLabel>Volumes of CO2 (vol. CO2)</ControlLabel>
          <FormControl
            type="number"
            step="0.01"
            min="0"
            max="10"
            placeholder="e.g. 2.50"
            value={volCo2}
            onChange={(e) => setVolCo2(e.target.value)}
            autoFocus
          />
          <HelpBlock style={{ fontSize: "12px", color: "#888" }}>
            Standard conversion: 1 vol. CO2 &asymp; 1.96 g/L CO2
          </HelpBlock>
        </FormGroup>

        <div
          style={{
            backgroundColor: "#f7f7f7",
            padding: "12px",
            borderRadius: "4px",
            textAlign: "center",
            marginTop: "10px",
            border: "1px solid #e3e3e3",
          }}
        >
          <span style={{ fontSize: "13px", color: "#555" }}>
            Equivalent in g/L CO2:
          </span>
          <div
            className="converted-co2-result"
            style={{
              fontSize: "22px",
              fontWeight: "bold",
              color: convertedGPerL ? "#2e7d32" : "#999",
              marginTop: "4px",
            }}
          >
            {convertedGPerL ? `${convertedGPerL} g/L CO2` : "-"}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Cancel</Button>
        <Button
          bsStyle="primary"
          className="btn-apply-co2"
          disabled={!convertedGPerL}
          onClick={handleApply}
        >
          Apply to recipe
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

Co2ConverterModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Co2ConverterModal;
